import { Button, Typography } from '@material-ui/core';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import { Assessment } from '@material-ui/icons';
import headerLinksStyle from 'assets/jss/material-dashboard-pro-react/components/headerLinksStyle';
import classNames from 'classnames';
import TaskList from 'components/SqTasks/TaskList.jsx';
import PropTypes from 'prop-types';
import React from 'react';
import { toggleProgressOpen } from 'reducers/TasksReducer';
import store from 'store';


class HeaderLinks extends React.Component {
	state = {
		open: false
	};
	handleClick = () => {
		this.setState({ open: !this.state.open });
	};
	handleClose = () => {
		this.setState({ open: false });
	};

	handleOpenTasks = () => {
		store.dispatch(toggleProgressOpen());
	};
	render() {
		const { classes, rtlActive } = this.props;
		const wrapper = classNames({
			[classes.wrapperRTL]: rtlActive
		});
		return (
			<div className={wrapper}>
				<Button
					onClick={() => this.handleOpenTasks()}
					style={{ marginRight: '15px', textTransform: 'none' }}
				>
					<Typography variant="caption" style={{ marginRight: '10px' }}>
						Quote Progress
					</Typography>

					<Assessment style={{ color: '#555270' }} />
				</Button>
				<TaskList />
			</div>
		);
	}
}

HeaderLinks.propTypes = {
	classes: PropTypes.object.isRequired,
	rtlActive: PropTypes.bool
};

export default withStyles(headerLinksStyle)(HeaderLinks);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx